module.exports = __webpack_public_path__ + "static/media/ic-approve-versions.ed84332e.svg";